import { connect } from 'react-redux';
import { injectIntl } from 'react-intl';
import { getTncDetail } from '../../redux/actions/tnc';

import TncDetail from './TncDetail.page';

const mapStateToProps = state => ({
  detail: state.allbiller.tncDetail,
  loading: state.allbiller.loading,
});

const mapDispatchToProps = { getTncDetail };

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(injectIntl(TncDetail));
